var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"fts-form-control",class:{ 'form-control--error': _vm.error },attrs:{"type":"text"},domProps:{"value":_vm.value},on:{"blur":_vm.onBlur}})}
var staticRenderFns = []
export { render, staticRenderFns }